import { api } from '@/services/api'

const STORAGE_KEY = 'sponsor'
const RESERVED_USERNAMES = ['sucesso']

export function getStoredSponsor() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function setStoredSponsor(user) {
  if (!user || !user.indication) return
  localStorage.setItem(STORAGE_KEY, JSON.stringify(user))
}

export function clearStoredSponsor() {
  localStorage.removeItem(STORAGE_KEY)
}

export function isReservedUsername(username) {
  return RESERVED_USERNAMES.includes(String(username || '').toLowerCase())
}

export async function fetchSponsor(indication) {
  const res = await api.post('user/sponsor', { indication })
  return res.data
}
